import { render, staticRenderFns } from "./ManageVideo.vue?vue&type=template&id=1702a348&"
import script from "./ManageVideo.vue?vue&type=script&lang=js&"
export * from "./ManageVideo.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/managevideo.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports